export class CosoConfig {
  coso_config_id: number | undefined;
  project_id: string | undefined;
  flow: string | null | undefined;
  provider: string | null | undefined;
  model: string | null | undefined;
  summarizationModel: string | null | undefined;
  guardrails_model: string | null | undefined;
  model_temperature: number | undefined;
  model_max_retries: number | undefined;
  cache_ttl: number | null | undefined;
  chat_history_limit: number | undefined;
  recursion_limit: number | undefined;
  system_message: string | null | undefined;
  live_system_message: string | null | undefined;
  live_audio_allowed: boolean | undefined;
  live_video_allowed: boolean | undefined;
  tokens_before_summarization: number | null | undefined;
  module_name: string | null | undefined;
  model_region: string | null | undefined;
  supported_file_mime_types: string[] | undefined;
  enabled_tools: CosoConfigEnabledTool[] | undefined;
  enabled_guardrails: CosoConfigGuardrail[] | undefined;
  enabled_guardrail_ids: number[] | undefined;
  fm_integration_enabled: boolean | undefined;
  fm_server_address: string | null | undefined;
  fm_odata_username: string | null | undefined;
  fm_odata_password: string | null | undefined;
}

export interface CosoConfigEnabledTool {
  tool_id: string;
  data_source_ids: string[];
  options: Record<string, unknown>;
}

export interface CosoConfigGuardrail {
  id_guardrail: number;
  action: 1 | 2 | 3;
}

export interface CosoConfigCapabilities {
  project_id: string;
  providers: CosoConfigProviderCapability[];
  tools: CosoConfigToolCapability[];
  dataSources: CosoConfigDataSourceCapability[];
  defaults: CosoConfigDefaults;
}

export interface CosoConfigProviderCapability {
  id: string;
  label: string;
  configSchema?: CosoJsonSchema;
  models?: CosoConfigModelCapability[];
}

export interface CosoConfigModelCapability {
  id: string;
  label: string;
  model: string;
  vendor?: string | null;
  region?: string | null;
  supportedFileMimeTypes: string[];
  prices: CosoConfigModelPrice[];
}

export interface CosoConfigModelPrice {
  modelPriceId?: number;
  vendor?: string | null;
  tokenType?: string | null;
  tokensLowerLimit?: number | null;
  tokensUpperLimit?: number | null;
  tokenPrice?: number | null;
}

export interface CosoConfigToolCapability {
  id: string;
  label: string;
  description: string;
  icon: string;
  requiresDataSources: boolean;
  dataSourceCapabilities: string[];
  compatibleDataSources: string[];
  optionsSchema?: CosoJsonSchema;
}

export interface CosoConfigDataSourceCapability {
  id: string;
  label: string;
  capabilities: string[];
}

export interface CosoConfigDefaults {
  provider?: string;
  providerDefaults?: Record<string, Record<string, unknown>>;
  enabled_tools?: CosoConfigEnabledTool[];
}

export interface CosoJsonSchema {
  type?: string;
  properties?: Record<string, CosoJsonSchemaProperty>;
  required?: string[];
}

export interface CosoJsonSchemaProperty {
  type?: string;
  default?: unknown;
  properties?: Record<string, CosoJsonSchemaProperty>;
  required?: string[];
  items?: CosoJsonSchemaProperty;
}
